import { forwardRef, useCallback, useRef, useState } from 'react';
import { InputBaseComponentProps } from '@mui/material';
import { useFormikContext } from 'formik';
import { CreditCardSecret } from '@styles/InputStyles';
import { InputMask } from '../InputWithMask';
import { ITextInputProps, TextInput } from '../TextInput';

const CreditCardMask = forwardRef(({ onChange, ...other }: InputBaseComponentProps) => {
  const creditCardMask = [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/];

  return <InputMask {...other} mask={creditCardMask} onChange={onChange} />;
});

export const CreditCardInput = (props: ITextInputProps) => {
  const ref = useRef<HTMLDivElement>();
  const [showSecret, setSecretStatus] = useState(false);
  const formik = useFormikContext();

  const handleClickOnSecret = useCallback(
    () => {
      setSecretStatus(false);

      ref.current?.querySelector('input')?.focus();
    },
    []
  );

  return (
    <div style={{ position: 'relative' }}>
      {showSecret && props.value as string && !props.error && <CreditCardSecret onClick={handleClickOnSecret}>**** **** ****</CreditCardSecret>}

      <TextInput 
        {...props} 
        fullWidth
        InputProps={{ inputComponent: CreditCardMask, ref }}
        onFocus={() => setSecretStatus(false)}
        onBlur={event => {
          formik?.handleBlur?.(event);
          setSecretStatus(true);
        }}
      />
    </div>
  );
};

